<script setup>
import { ref, toRefs, onBeforeMount } from 'vue'
import BaseRadio from '@/src/vueComponent/BaseRadio.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'
import { SendOutlined } from '@ant-design/icons-vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'

const props = defineProps({
  token: {
    type: String
  },
  qualityFeedbackData: {
    type: Object
  },
  procedureList: {
    type: Array,
    default: () => []
  }
})

const { token, qualityFeedbackData, procedureList } = toRefs(props)

const documentsData = ref({
  quality_feedback_id: null,
  procedure_id: null,
  steps_attributes: [
    {
      step: '',
      step_name: '',
      signer_id: ''
    }
  ]
})
const categoryList = ref([])
onBeforeMount(() => {
  documentsData.value = {
    ...documentsData.value,
    quality_feedback_id: qualityFeedbackData.value.id
  }

  categoryList.value = procedureList.value.filter((item) => {
    if (qualityFeedbackData.value.customer.category === 'strand') {
      return item.category.includes('strand') || item.category.includes('other')
    } else {
      return item.category.includes(qualityFeedbackData.value.customer.category)
    }
  })
})

const changeProcedureValue = (value) => {
  const procedureResult = categoryList.value.find((item) => {
    return item.name === value
  })

  documentsData.value.procedure_id = procedureResult.id
  documentsData.value.steps_attributes = procedureResult.steps.map((step) => {
    return {
      step: step.step,
      step_name: step.step_name,
      signer_id: null,
      members: step.members.length
        ? step.members.map((member) => ({ label: member.name, value: member.id }))
        : []
    }
  })
}

const handleSubmit = () => {
  const stepsAttributeList = documentsData.value.steps_attributes.map((step) => {
    const { members, ...rest } = step
    return { ...rest }
  })
  const formData = { ...documentsData.value, steps_attributes: stepsAttributeList }

  $.ajax({
    url: '/documents',
    type: 'POST',
    dataType: 'json',
    headers: { 'X-CSRF-Token': token.value },
    authenticity_token: true,
    data: formData,
    success: async (response) => {
      if (response.state === 0) {
        mySwal
          .success({
            title: response.message
          })
          .then(() => {
            $(document).off('turbo:before-visit')
            Turbo.visit(`/documents/${response.document_id}`)
          })
      }
    },
    error: async (error) => {
      console.log('error', error)
      if (error.responseJSON.state === -1) {
        await mySwal.error({
          title: error.responseJSON.message.join('<br />'),
          timer: 3000
        })

        if (error.responseJSON.redirect_to) {
          window.location.replace(error.responseJSON.redirect_to)
        }
      }
    }
  })
}
</script>
<template>
  <div>
    <h3 class="py-2.5 text-2xl font-bold">內部簽核單</h3>
    <div class="mb-4 grid grid-cols-3 rounded-md border border-gray-200 xl:grid-cols-2">
      <div class="rounded-none border border-y-0 border-l-0 border-gray-200 p-4">
        <label class="mb-2 block text-xl font-bold">發起人</label>
        <div>
          {{ qualityFeedbackData.applicant.company ?? '' }}
          {{ qualityFeedbackData.applicant.unit ?? '' }}
          {{ qualityFeedbackData.applicant.name ?? '' }}
        </div>
      </div>
      <div class="rounded-none border border-y-0 border-l-0 border-gray-200 p-4">
        <label class="mb-2 block text-xl font-bold">品質回報單號</label>
        <div>{{ qualityFeedbackData.feedback_code }}</div>
      </div>
      <div class="rounded-none border-gray-200 p-4">
        <label class="mb-2 block text-xl font-bold">客戶</label>
        <div>{{ qualityFeedbackData.customer.name }}</div>
      </div>
    </div>
    <div>
      <form @submit.prevent="handleSubmit" class="leave-need-confirm">
        <div class="mb-4">
          <p class="mb-2 text-xl font-bold">
            <span class="mr-2">製造資料</span>
            <span class="mr-2">-</span>
            <span>{{ qualityFeedbackData.customer.category === 'strand' ? '絞線' : '其他' }}</span>
          </p>
          <div class="mb-2 flex w-full gap-3">
            <div v-for="category in categoryList" :key="category.id">
              <BaseRadio
                :label="category.name"
                :name="'procedure_id'"
                :value="category.name"
                @update:modelValue="changeProcedureValue"
                required
              />
            </div>
          </div>
        </div>
        <div v-if="documentsData.procedure_id && documentsData.steps_attributes.length !== 0">
          <p class="mb-2 text-xl font-bold">設定關卡</p>
          <div class="flex w-full gap-3">
            <div v-for="step in documentsData.steps_attributes" :key="step.id" class="flex-1">
              <BaseSelect
                class="flex-1"
                :label="step.step_name"
                :name="'unit_id'"
                :optionList="step.members"
                :optionsSelected="step.signer_id"
                @select="step.signer_id = $event"
                required
              />
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end gap-3 py-3">
          <BackButton
            :hasForm="true"
            :returnPath="`/quality_feedbacks/${qualityFeedbackData.id}`"
          />
          <button type="submit" class="btn btn-success text-xl text-white">
            <SendOutlined />
            送出
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
